import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { getPathWithParams } from "../../../helpers/router";
import { businessRoutes } from "../../../utils/routes";
import graf1 from "../../assets/intro/graf-1.svg";
import Animate from "../Animate";

const Intro = ({ t, language }) => (
  <Fragment>
    <div id="intro" className="landing-container-intro">
      <div className="landing-layout">
        <div className="landing-page-intro">
          <div className="landing-page-intro-content">
            <Animate>
              <h2 className="landing-section-title">{t("landing.intro.title")}</h2>
            </Animate>
            <p className="landing-section-text">{t("landing.intro.subtitle")}</p>
            <Link
							  className="landing-animated landing-button-red"
								to={getPathWithParams({
									path: businessRoutes.register,
									params: { language },
                  app:'business'
								})}
							>
								 {t("landing.intro.button")}
							</Link>
           
          </div>

          <div className="landing-page-intro-image">
            <img className="landing-page-intro-image" src={graf1} alt="" />
          </div>
        </div>
        <div className="landing-line"></div>
      </div>
    </div>
  </Fragment>
);

export default Intro;
